<mat-form-field appearance="outline" class="w-full">
  <mat-label>Error Threshold Type</mat-label>
  <mat-select [formControl]="failedConditionControl">
    <mat-option [value]="'absolute'">Absolute</mat-option>
    <mat-option [value]="'relative'">Relative</mat-option>
    <mat-select-trigger>
      {{ failedConditionControl.value === 'relative' ? 'Relative' : 'Absolute' }}
    </mat-select-trigger>
  </mat-select>
</mat-form-field>

<mat-form-field class="w-full" appearance="outline">
  <mat-label>
    Excepted Threshold Value
    <span *ngIf="failedConditionControl.value === 'relative'">(0 to 1)</span>
  </mat-label>
  <input
    type="number"
    matInput
    autocomplete="off"
    [step]="failedConditionControl.value === 'relative' ? 'any' : '1'"
    [formControl]="failedByConditionControl"
  />
  <mat-error *ngIf="failedByConditionControl.errors?.required" class="mat-error-default">Value is required</mat-error>
  <mat-error *ngIf="failedByConditionControl.errors?.min as errorMin" class="mat-error-default">
    Value should be more than {{ errorMin.min }}
  </mat-error>
  <mat-error *ngIf="failedByConditionControl.errors?.max as errorMax" class="mat-error-default">
    Value should be less than {{ errorMax.max }}
  </mat-error>
  <mat-error *ngIf="failedByConditionControl.errors?.integer" class="mat-error-default">
    Value should be integer
  </mat-error>
</mat-form-field>
